import { getContentFromJson } from '@/services';

const actions = {
  loadContentForView: async ({ commit }, viewName) => {
    const content = await getContentFromJson(viewName);
    commit('loadContent', { content, viewName });
  },
};

export default actions;
